const ACTIVE_RECALCULATION_JOB_STATUSES = ["queued", "starting", "running"];

export function getManualRecalculationJobExpiryMillis(job) {
  const expiresAt = job?.expiresAt;

  if (!expiresAt) {
    return NaN;
  }

  if (typeof expiresAt.toMillis === "function") {
    return expiresAt.toMillis();
  }

  if (typeof expiresAt.toDate === "function") {
    return expiresAt.toDate().getTime();
  }

  if (expiresAt instanceof Date) {
    return expiresAt.getTime();
  }

  if (typeof expiresAt.seconds === "number") {
    return (expiresAt.seconds * 1000)
      + Math.floor((expiresAt.nanoseconds ?? 0) / 1000000);
  }

  if (typeof expiresAt === "number") {
    return expiresAt;
  }

  if (typeof expiresAt === "string") {
    return Date.parse(expiresAt);
  }

  return NaN;
}

export function isManualRecalculationJobRunning(job, now = Date.now()) {
  if (!ACTIVE_RECALCULATION_JOB_STATUSES.includes(job?.status)) {
    return false;
  }

  const expiresAtMillis = getManualRecalculationJobExpiryMillis(job);

  return Number.isFinite(expiresAtMillis) && expiresAtMillis > now;
}
